// ABOUTME: Zod schemas and inferred types for TechLog sector de-ice event API data.
import { z } from 'zod';

/**
 * De-ice event from `GET /sectors/{id}/deice-events`.
 *
 * `startTime` and `endTime` are plain strings rather than `ZdateTime`: real
 * values include localized `YYYY/MM/DD hh:mm AM`, time-only `HH:mm`, and
 * malformed cross-day combinations, so the API does not honour its documented
 * ISO contract. `fluidType` covers `I`, `II`, `III`, `IV`, `V` and `E`.
 * `quantity` has no documented unit and is entered as litres.
 * `fluidRatioLeft` is the fluid concentration and `fluidRatioRight` the water,
 * so the pair complements to 100: an entered 40 renders as 40/60.
 */
export const ZTechlogDeiceEvent = z.object({
  id: z.string(),
  sectorId: z.string().nullable().optional(),
  startTime: z.string().nullable().optional(),
  endTime: z.string().nullable().optional(),
  fluidType: z.string().nullable().optional(),
  fluidRatioLeft: z.number().nullable().optional(),
  fluidRatioRight: z.number().nullable().optional(),
  quantity: z.number().nullable().optional(),
  holdoverSeconds: z.number().nullable().optional(),
  holdoverTime: z.number().nullable().optional(),
  attachments: z.array(z.unknown()).optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
});

// The endpoint returns a `records` envelope despite the OpenAPI spec documenting `results`.
export const ZTechlogDeiceEventsResponse = z.object({
  records: z.array(ZTechlogDeiceEvent),
});

export type TechlogDeiceEvent = z.infer<typeof ZTechlogDeiceEvent>;
